// Health-history text fields (allergic, congenitalDisease, medicationHistory) are
// stored as plain text with items joined by ", ". These helpers turn that text into
// chip items and back, and read the old "nothing" values ("-", "ไม่มี", ...) as ปฏิเสธ.

export const HEALTH_DENIED = "ปฏิเสธ";

const NOTHING_VALUES = new Set([
  "-", "--", "ไม่มี", "ไม่แพ้", HEALTH_DENIED, "none", "no", "nil", "n/a",
]);
const SEPARATOR = /[,;\n]/;

const isNothing = item => NOTHING_VALUES.has(item.trim().toLowerCase());

export function toItems(text) {
  const items = [];
  String(text ?? "")
    .split(SEPARATOR)
    .map(s => s.trim())
    .filter(Boolean)
    .forEach(s => {
      if (!items.includes(s)) items.push(s);
    });
  if (!items.length) return [];
  const real = items.filter(s => !isNothing(s));
  return real.length ? real : [HEALTH_DENIED];
}

export function fromItems(items) {
  return (items || []).join(", ");
}

export function normalize(text) {
  return fromItems(toItems(text));
}

export function isDenied(text) {
  return normalize(text) === HEALTH_DENIED;
}

export function hasValue(text) {
  const items = toItems(text);
  return items.length > 0 && items[0] !== HEALTH_DENIED;
}

/** What a header shows for a field: the normalized text ("-" when empty) and whether it is a real finding. */
export function healthDisplay(text) {
  const value = normalize(text);
  return { text: value || "-", danger: hasValue(text) };
}

/**
 * Apply a pick to the chip list: choosing ปฏิเสธ replaces every other chip,
 * choosing anything else drops ปฏิเสธ.
 */
export function pickItems(prev, next) {
  const before = prev || [];
  const after = next || [];
  if (!after.includes(HEALTH_DENIED)) return after;
  if (!before.includes(HEALTH_DENIED)) return [HEALTH_DENIED];
  return after.length > 1 ? after.filter(i => i !== HEALTH_DENIED) : after;
}

/** Add typed free text (may hold several comma-separated items) to the chip list. */
export function addTyped(items, text) {
  const typed = toItems(text);
  if (!typed.length) return items || [];
  const merged = [...(items || [])];
  typed.forEach(t => {
    if (!merged.includes(t)) merged.push(t);
  });
  return pickItems(items, merged);
}
